import { useState, useEffect, useCallback } from "react";

const useTransactionTimer = (processing) => {
  const [transactionTimeInSeconds, setTransactionTimeInSeconds] = useState(0);

  const incrementTransactionTime = useCallback(() => {
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setTransactionTimeInSeconds((time) => time + 1);
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [processing]);

  useEffect(() => {
    const timerCleanup = incrementTransactionTime();
    return () => timerCleanup();
  }, [transactionTimeInSeconds, processing, incrementTransactionTime]);

  const resetTransactionTimer = useCallback(() => {
    setTransactionTimeInSeconds(0);
  }, []);

  return [transactionTimeInSeconds, resetTransactionTimer];
};

export default useTransactionTimer;
